// @flow
import { system, type Config } from 'styled-system';
import type { FontWeight } from '@rover/design-system/style-dictionary/build/es6/theme';
import { WEB_FALLBACK_FONT_FAMILIES } from '@rover/design-system/style-dictionary/build/es6/theme';

export type FontWeightProps = {|
  fontWeight?: FontWeight,
|};

type FontFamily = 'Averta-Regular' | 'Averta-Semibold' | 'Averta-Extrabold';

const getFontFamilyForWeight = (weight: FontWeight): FontFamily => {
  switch (weight) {
    case 'extrabold':
      return 'Averta-Extrabold';
    case 'semibold':
      return 'Averta-Semibold';
    case 'regular':
    default:
      return 'Averta-Regular';
  }
};

const config: Config<FontWeightProps> = {
  fontWeight: {
    property: 'fontFamily',
    scale: 'fontWeight',
    transform: propValue => {
      const fontFamily = getFontFamilyForWeight(propValue);
      // if not on react native, append fallback fonts
      if (!process.env.JS_ENV_NATIVE) {
        return `${fontFamily}, ${WEB_FALLBACK_FONT_FAMILIES}`;
      }
      return fontFamily;
    },
  },
};

export default system<FontWeightProps>(config);



// WEBPACK FOOTER //
// ../react-lib/src/styles/styled-system/fontWeight.js